const colorPalette = (elementsCount: number): Array<string> => {
  if (elementsCount === 1) {
    return ["#008ffb"];
  }
  if (elementsCount === 2) {
    return ["#008ffb", "#00e396"];
  }
  if (elementsCount === 3) {
    return ["#008ffb", "#00e396", "#79D9D9"];
  }
  if (elementsCount === 4) {
    return ["#008ffb", "#00e396", "#79D9D9", "#feb019"];
  }
  if (elementsCount === 5) {
    return ["#008ffb", "#00e396", "#79D9D9", "#feb019", "#775dd0"];
  }
  if (elementsCount === 6) {
    return ["#008ffb", "#00e396", "#79D9D9", "#feb019", "#775dd0", "#ff4560"];
  }
  if (elementsCount === 7) {
    return [
      "#008ffb",
      "#00e396",
      "#79D9D9",
      "#feb019",
      "#775dd0",
      "#ff4560",
      "#333333",
    ];
  }
  return ["#008ffb", "#00e396", "#79D9D9", "#feb019", "#775dd0"];
};

export { colorPalette as default };
